module.exports = __webpack_public_path__ + "img/microsoft_logo.f32b3f89.svg";